// components/markdown/Svg.tsx
import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { BaseCustomProps } from './types';

interface SvgProps extends BaseCustomProps {
  // Additional props specific to SVG if needed
  viewBox?: string;
  width?: string | number;
  height?: string | number;
}

export const Svg: React.FC<SvgProps> = ({ 
  children,
  className,
  viewBox,
  width,
  height,
  ...props 
}) => {
  // Use dangerouslySetInnerHTML to render the SVG content directly
  // This is needed because SVG needs to be rendered as HTML, not as text
  if (typeof children === 'string') {
    return (
      <div 
        className={twMerge('svg-container my-4', className)}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  }
  
  // Fall back to regular SVG rendering if children isn't a string
  return (
    <svg
      className={twMerge('my-4', className)}
      viewBox={viewBox}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
};